<template>
  <!-- Registration-form -->
  <div class="registration-form l-container">
    <!-- Step -->
    <div class="step">
      <Step :currentStep="3" :steps="steps" />
    </div>
    <div class="title-top">お申し込み内容のご確認</div>
    <div class="divider-top"></div>
    <div class="box">
      <div class="box-content">
        <!-- Item-order -->
        <div>
          <Item :data="dataItemOrder" />
        </div>
        <!-- Customer-info -->
        <div class="customer-info">
          <!-- Title -->
          <div class="customer-info-title">
            <SectionContentTitle
              :lineType="'v-line'"
              :titleContent="'申込者情報'"
              class="my-auto text-xl sm:text-sm"
            />
          </div>
          <!-- Customer-information -->
          <CustomerInfo :profileInfo="profileInfo" @onChange="getCustomerInfo($event)" />
          <div class="modify-button">
            <a-button @click="handleEdit()" size="large" class="text-bold sm:text-sm"
              >変更する</a-button
            >
          </div>
        </div>
        <a-divider />
        <!-- Item-detail -->
        <div class="customer-info-detail">
          <SectionContentTitle
            :lineType="'v-line'"
            :titleContent="'お申し込み内容'"
            class="pb-0 pt-4 text-xl sm:text-sm"
          />
          <!-- <TableDetail v-model="TableDetail1" /> -->
          <div>
            <table class="table-common">
              <tr class="label-inp" style="border: 0px">
                <td class="flex style-l" style="border-bottom: 0px; border-right: 0px">
                  <div class="font-bold label-l">宿泊期間</div>
                  <!-- <div class="ml-4 category">必須</div> -->
                </td>
                <td class="data" style="border-bottom: 0px">
                  <div class="items-data">
                    <div class="label-data w-full">
                      <span class="mr-2">{{ stayDay }}</span>
                      <span class="mr-2" v-if="nightCnt">{{ nightCnt }}泊</span>
                      <!-- <span class="mr-2" v-if="stayRoom">{{ stayRoom }}部屋</span>
                      <span class="mr-2"
                        >（大人{{ totalAdult | formatInteger }}名/子ども{{
                          totalChild | formatInteger
                        }}名）</span
                      > -->
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="label-inp" style="border: 0px">
                <td class="flex style-l" style="border-right: 0px">
                  <div class="font-bold label-l w-full">ご利用案内書の受け取り方法</div>
                  <!-- <div class="ml-4 category">必須</div> -->
                </td>
                <td class="data">
                  <div class="items-data">
                    <div class="label-data w-full">
                      <span v-show="+selectedRadio === 1"> WEBからプリントアウト</span>
                      <span v-show="+selectedRadio === 2"> 郵送</span>
                    </div>
                  </div>
                </td>
              </tr>
              <!-- <tr class="label-inp border-t-0">
                <td class="flex style-l">
                  <div class="font-bold label-l">チェックイン時間</div>
                  <div class="ml-4 category">必須</div>
                </td>
                <td class="data">
                  <div class="items-data">
                    <div class="label-data">
                      <span> 00:00</span>
                    </div>
                  </div>
                </td>
              </tr> -->
            </table>
          </div>

          <!-- <div>ご利用案内書の受け取り方法 :
            <span v-show="+selectedRadio === 1"> WEBからプリントアウト</span>
            <span v-show="+selectedRadio === 2"> 郵送</span>
          </div> -->

          <!-- <div v-for="(item, index) in customerPlan.stayRooms" :key="index"> -->
          <!-- <SectionContentTitle
            :lineType="'v-line'"
            :titleContent="'部屋'"
            class="text-xl sm:text-sm"
          /> -->
          <div v-for="(item, idx) in peopleRoom" :key="`tbl-key-a-${idx}`">
            <SectionContentTitle
              :lineType="'v-line'"
              :titleContent="`${idx + 1}部屋目`"
              class="pb-4 pt-6 text-xl sm:text-sm relative"
            />
            <table class="table-common">
              <tr>
                <th class="p-4 w-1/5"></th>
                <th class="main_col w-1/5">会員 (補助対象) 人数</th>
                <th class="main_col w-1/5">宿泊料金<br>(1泊1名あたり)</th>
                <th class="main_col w-1/5">ビジター (補助対象外)人数</th>
                <th class="main_col w-1/5">宿泊料金<br>(1泊1名あたり)</th>
              </tr>
              <tr>
                <td class="main_col font-bold">大人(中学生以上)</td>
                <td>
                  {{ item.member && item.member.man ? item.member.man : 0 }}
                  <span class="ml-1">名</span>
                </td>
                <td>
                  <div>
                    {{ item.member && item.member.manPrice ? item.member.manPrice : 0 }}
                    <span class="ml-1">円</span>
                  </div>
                </td>
                <td>
                  {{ item.visitors && item.visitors.man ? item.visitors.man : 0 }}
                  <span class="ml-1">名</span>
                </td>
                <td>
                  <div>
                    {{ item.visitors && item.visitors.visitorManPrice ? item.visitors.visitorManPrice : 0 }}
                    <span class="ml-1">円</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="font-bold main_col">有料の小学生</td>
                <td>                    
                  {{ item.children && item.children.childrenMember10 ? item.children.childrenMember10 : 0 }}
                  <span class="ml-1">名</span></td>
                <td>
                  <div>
                    {{ item.children && item.children.childrenMember10Price ? item.children.childrenMember10Price : 0 }}
                    <span class="ml-1">円</span>
                  </div> 
                </td>
                <td>
                  {{ item.children && item.children.childrenVisitor10 ? item.children.childrenVisitor10 : 0 }}
                  <span class="ml-1">名</span>
                </td>
                <td>
                  <div>
                    {{ item.children && item.children.childrenVisitor10Price ? item.children.childrenVisitor10Price : 0 }}
                    <span class="ml-1">円</span>
                  </div> 
                </td>
              </tr>
              <tr>
                <td class="font-bold main_col">有料の幼児<br>※弊社補助対象外</td>
                <td>                    
                  {{ item.children && item.children.childrenMember15 ? item.children.childrenMember15 : 0 }}
                  <span class="ml-1">名</span> 
                </td>
                <td>                    
                  <div>
                    {{ item.children && item.children.childrenMember15Price ? item.children.childrenMember15Price : 0 }}
                    <span class="ml-1">円</span>
                  </div>  
                </td>
                <td></td>
                <td></td>
              </tr>
            </table>
            <!-- <table class="table-common">
              <tr class="label-inp">
                <td class="flex style-l">
                  <div class="font-bold label-l">会員</div>
                </td>
                <td class="data">
                  <div class="items-data">
                    <div class="label-data w-full">
                      <div class="grid" v-if="item">
                        <span v-if="item.member && item.member.man">
                          大人 {{ item.member.man }} 名 
                          <span v-if="item.member && item.member.manPrice">: {{ item.member.manPrice }}円</span>      
                        </span>

                        <span v-if="item.member && item.member.woman"
                          >大人女性 {{ item.member.woman }} 名
                        </span>
                        <span v-if="item.children && item.children.childrenMember10">
                          有料の小学生 {{ item.children.childrenMember10 }} 名
                          <span v-if="item.children && item.children.childrenMember10Price">: {{ item.children.childrenMember10Price }}円</span>
                        </span>
                        <span v-if="item.children && item.children.childrenMember15">
                          有料の幼児 {{ item.children.childrenMember15 }} 名
                          <span v-if="item.children && item.children.childrenMember15Price">: {{ item.children.childrenMember15Price }}円</span>  
                        </span>
                        <span v-if="item.children && item.children.childrenMember20">
                          食事・布団付 {{ item.children.childrenMember20 }} 名</span
                        >
                        <span v-if="item.children && item.children.childrenMember30">
                          食事のみ {{ item.children.childrenMember30 }} 名</span
                        >
                        <span v-if="item.children && item.children.childrenMember40">
                          布団のみ {{ item.children.childrenMember40 }} 名</span
                        >
                        <span v-if="item.children && item.children.childrenMember50">
                          食事・布団不要 {{ item.children.childrenMember50 }} 名</span
                        >
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="label-inp border-t-0">
                <td class="flex style-l">
                  <div class="font-bold label-l">ビジター</div>
                </td>
                <td class="data">
                  <div class="items-data">
                    <div class="label-data w-full">
                      <div class="grid" v-if="item">
                        <span v-if="item.visitors && item.visitors.man"
                          >大人 {{ item.visitors.man }} 名
                          <span v-if="item.visitors && item.visitors.visitorManPrice">: {{ item.visitors.visitorManPrice }}円</span> 
                        </span>
                        <span v-if="item.visitors && item.visitors.woman"
                          >大人女性 {{ item.visitors.woman }} 名
                        </span>
                        <span v-if="item.children && item.children.childrenVisitor10">
                          有料の小学生 {{ item.children.childrenVisitor10 }} 名
                         <span v-if="item.children && item.children.childrenVisitor10Price">: {{ item.children.childrenVisitor10Price }}円</span> 
                        </span> 
                        <span v-if="item.children && item.children.childrenVisitor15">
                          低学年 {{ item.children.childrenVisitor15 }} 名
                            <span v-if="item.children && item.children.childrenVisitor15Price">: {{ item.children.childrenVisitor15Price }}円</span> 
                        </span>
                        <span v-if="item.children && item.children.childrenVisitor20">
                          食事・布団付 {{ item.children.childrenVisitor20 }} 名</span
                        >
                        <span v-if="item.children && item.children.childrenVisitor30">
                          食事のみ {{ item.children.childrenVisitor30 }} 名</span
                        >
                        <span v-if="item.children && item.children.childrenVisitor40">
                          布団のみ {{ item.children.childrenVisitor40 }} 名</span
                        >
                        <span v-if="item.children && item.children.childrenVisitor50">
                          食事・布団不要 {{ item.children.childrenVisitor50 }} 名</span
                        >
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </table> -->
            <!-- <div class="font-bold absolute right-0 pr-60" st>{{idx+1}}部屋目の宿泊料合計:{{totalRoomCharge[idx]}}</div> -->

            <!-- <div class="total-price">
              <p class="total-price-text font-16">
                {{ idx + 1 }}部屋目の宿泊料合計:
              </p>
              <p class="total-price-amount font-16">
                {{ totalRoomCharge[idx] | formatCurrency }}
              </p>
            </div> -->
          </div>

          <!-- <div class="total-price">
            <p class="total-price-text">宿泊料合計</p>
            <p class="total-price-amount">{{ feePeople | formatCurrency }}</p>
          </div> -->

          <!-- <SectionContentTitle
            :titleContent="'宿泊代表者'"
            class="text-base mt-8 pb-2 sm:text-xs"
          />
          <div v-if="!valueCheckbox02_001">
            <span>宿泊代表者は申込者と同じ</span>
          </div>
          <div v-if="valueCheckbox02_001">
            <span>宿泊代表者は申込者と異なる</span>
            <table class="table-common">
              <tr class="label-inp">
                <td class="flex style-l">
                  <div class="font-bold label-l">宿泊代表者</div>
                  <div class="ml-4 category">必須</div>
                </td>
                <td class="data">
                  <div class="items-data">
                    <div class="label-data w-full">
                      <div class="content-data collapse-data pb-5">
                        <div class="elm1">氏名（漢字・ローマ字）</div>
                        <div class="elm2">{{ representPersonInfo.name }}</div>
                      </div>
                      <div class="content-data collapse-data pb-5">
                        <div class="elm1">会員との続柄</div>
                        <div class="elm2">
                          {{ representPersonInfo.familyRelationship }}
                        </div>
                      </div>
                      <div class="content-data collapse-data pb-5">
                        <div class="elm1">会員・ビジター</div>
                        <div class="elm2">
                          {{ representPersonInfo.isVisitor }}
                        </div>
                      </div>
                      <div class="content-data collapse-data pb-5">
                        <div class="elm1">性別</div>
                        <div class="elm2">{{ representPersonInfo.gender }}</div>
                      </div>
                      <div class="content-data collapse-data">
                        <div class="elm1">年齢</div>
                        <div class="elm2">{{ representPersonInfo.age }}歳</div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </table>
          </div> -->

          <div class="checklist" v-for="(item, index) in questionList" :key="index">
            <div class="main-checklist" v-if="item.replyRem">
              <div class="checklist-title">
                {{ item.qstnCont }}
                <div class="w-8 ml-1 mt-1 category" v-if="item.replyIdpsbFlag === '1'">
                  必須
                </div>
              </div>
              <div class="checklist-content">
                <div class="pl-5 py-4">
                  <p v-html="item.replyRem" style="white-space: pre-wrap"></p>
                </div>
              </div>
            </div>
          </div>

          <div class="modify-button">
            <a-button
              @click="handleEdit(2)"
              size="large"
              class="text-bold sm:text-sm hidden"
              >変更する</a-button
            >
          </div>
          <!-- <a-divider /> -->

          <!--          <SectionContentTitle-->
          <!--            :lineType="'v-line'"-->
          <!--            :titleContent="'補助クーポン利用申請'"-->
          <!--            class="pb-4 pt-4 text-xl sm:text-sm"-->
          <!--          />-->
          <!--          &lt;!&ndash; Company-subsidize &ndash;&gt;-->
          <!--          <div class="company-subsidize hidden">-->
          <!--            <span class="text">企業補助適用額</span>-->
          <!--            <span class="money">{{ fee4 }} 円</span>-->
          <!--          </div>-->
          <!--          <div class="auxiliary-coupon">-->
          <!--            &lt;!&ndash; Coupon-A &ndash;&gt;-->
          <!--            <div class="label-coupon hidden">-->
          <!--              <span class="type">補助クーポンA</span>-->
          <!--              <span class="description">-->
          <!--                適用条件：対象期間 2021年4月1日〜2022年3月31日-->
          <!--              </span>-->
          <!--            </div>-->
          <!--            <div class="hidden">-->
          <!--              <table class="table-common">-->
          <!--                <tr class="label-inp">-->
          <!--                  <td class="flex style-l">-->
          <!--                    <div class="font-bold label-l">数量</div>-->
          <!--                    <div class="ml-4 category">必須</div>-->
          <!--                  </td>-->
          <!--                  <td class="data">-->
          <!--                    <div class="items-data">-->
          <!--                      <div class="label-data w-full">-->
          <!--                        <div class="sub-items">-->
          <!--                          <div class="grid">-->
          <!--                            <span> 大人男性 1名 </span>-->
          <!--                            <span> 大人男性 1名 </span>-->
          <!--                          </div>-->
          <!--                          <div class="grid price-cal">-->
          <!--                            <span> </span>-->
          <!--                            <span class="font-bold"> 3,000円分 </span>-->
          <!--                          </div>-->
          <!--                        </div>-->
          <!--                      </div>-->
          <!--                    </div>-->
          <!--                  </td>-->
          <!--                </tr>-->
          <!--                <tr class="label-inp">-->
          <!--                  <td class="flex style-l">-->
          <!--                    <div class="font-bold label-l">代表宿泊者</div>-->
          <!--                    <div class="ml-4 category">必須</div>-->
          <!--                  </td>-->
          <!--                  <td class="data">-->
          <!--                    <div class="items-data">-->
          <!--                      <div class="label-data w-full">-->
          <!--                        <div class="sub-items">-->
          <!--                          <div class="grid">-->
          <!--                            <span> 大人男性 1名 </span>-->
          <!--                            <span> 大人男性 1名 </span>-->
          <!--                          </div>-->
          <!--                        </div>-->
          <!--                      </div>-->
          <!--                    </div>-->
          <!--                  </td>-->
          <!--                </tr>-->
          <!--              </table>-->
          <!--            </div>-->
          <!--            &lt;!&ndash; Coupon-B &ndash;&gt;-->
          <!--            <div class="label-coupon">-->
          <!--              <span class="type">ベネフィット・ワン補助金</span>-->
          <!--              <span class="description"> 適用条件：大人 </span>-->
          <!--            </div>-->
          <!--            &lt;!&ndash; Table-detail-6 &ndash;&gt;-->
          <!--            <div>-->
          <!--              <table class="table-common">-->
          <!--                <tr class="label-inp">-->
          <!--                  <td class="flex style-l">-->
          <!--                    <div class="font-bold label-l">数量</div>-->
          <!--                    <div class="ml-4 category">必須</div>-->
          <!--                  </td>-->
          <!--                  <td class="data">-->
          <!--                    <div class="items-data">-->
          <!--                      <div class="label-data w-full">-->
          <!--                        <div class="sub-items">-->
          <!--                          <div class="grid">-->
          <!--                            <span>-->
          <!--                              {{ couponLabel }}-->
          <!--                            </span>-->
          <!--                          </div>-->
          <!--                          <div class="grid price-cal">-->
          <!--                            <span class="font-bold">-->
          <!--                              {{ totalSubsidyDiscount | formatCurrency }}分-->
          <!--                            </span>-->
          <!--                          </div>-->
          <!--                        </div>-->
          <!--                      </div>-->
          <!--                    </div>-->
          <!--                  </td>-->
          <!--                </tr>-->
          <!--              </table>-->
          <!--            </div>-->
          <!--            <div class="modify-button">-->
          <!--              <a-button-->
          <!--                @click="handleEditUseCoupon(3)"-->
          <!--                size="large"-->
          <!--                class="text-bold sm:text-sm"-->
          <!--                >変更する</a-button-->
          <!--              >-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <a-divider />-->

          <!--          <div class="benepo-usage-app">-->
          <!--            <SectionContentTitle-->
          <!--              :lineType="'v-line'"-->
          <!--              :titleContent="'ベネポ利用申請'"-->
          <!--              class="pt-8 text-xl sm:text-sm"-->
          <!--            />-->
          <!--            <div>-->
          <!--              <table class="table-common">-->
          <!--                <tr class="label-inp">-->
          <!--                  <td class="flex style-l">-->
          <!--                    <div class="font-bold label-l">数量</div>-->
          <!--                    <div class="ml-4 category">必須</div>-->
          <!--                  </td>-->
          <!--                  <td class="data">-->
          <!--                    <div class="items-data">-->
          <!--                      <div class="label-data w-full">-->
          <!--                        <div class="sub-items">-->
          <!--                          <div class="grid">-->
          <!--                            <span>-->
          <!--                              {{ benepointLabel }}-->
          <!--                            </span>-->
          <!--                          </div>-->
          <!--                          <div class="grid price-cal">-->
          <!--                            <span> </span>-->
          <!--                            <span class="font-bold">-->
          <!--                              {{ benepo_point | formatCurrency }}分-->
          <!--                            </span>-->
          <!--                          </div>-->
          <!--                        </div>-->
          <!--                      </div>-->
          <!--                    </div>-->
          <!--                  </td>-->
          <!--                </tr>-->
          <!--              </table>-->
          <!--            </div>-->
          <!--            <div class="modify-button">-->
          <!--              <a-button-->
          <!--                @click="handleEdit(4)"-->
          <!--                size="large"-->
          <!--                class="text-bold sm:text-sm"-->
          <!--                >変更する</a-button-->
          <!--              >-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <a-divider class="mb-2" />-->

          <div class="fees hidden">
            <div class="fee-item">
              <div class="item-title">
                <span>宿泊料合計</span>
              </div>
              <div class="item-price">
                <span>{{ feePeople | formatCurrency }}</span>
              </div>
            </div>
            <div class="fee-item py-3">
              <div class="item-title-1">
                <p>（うち消費税（10%）</p>
              </div>
              <div class="item-price-1">
                <p>{{ Math.round(feePeople * (1 / 11)) | formatCurrency }})</p>
              </div>
            </div>

            <!--            <div class="fee-item py-3">-->
            <!--              <div class="item-title">-->
            <!--                <span>申請額合計②</span>-->
            <!--              </div>-->
            <!--              <div class="item-price">-->
            <!--                <span>{{-->
            <!--                  Math.ceil(fee4 + benepo_point + totalSubsidyDiscount)-->
            <!--                    | formatCurrency-->
            <!--                }}</span>-->
            <!--              </div>-->
            <!--            </div>-->
            <div class="fee-item py-3 hidden">
              <div class="item-title">
                <span>負担予定額</span>
              </div>
              <div class="item-price">
                <span>{{ totalCost | formatCurrency }}</span>
              </div>
            </div>
            <div class="fee-item hidden">
              <div class="item-title">
                <p>獲得予定ベネポ</p>
              </div>
              <div class="item-price">
                <p>200</p>
              </div>
            </div>
            <div class="text-notifi hidden">
              <p>
                ※ベネポ付与にあたっては、テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト
              </p>
            </div>
          </div>

          <!-- <a-divider class="hidden" /> -->
          <div class="hidden">
            <!-- <SectionContentTitle
              :titleContent="'変更・キャンセルについて'"
              class="pb-1 pt-4 text-sm sm:text-sm sm:pb-2"
            /> -->
            <div class="confirmation-detail pt-5">
              <p>
                ※テキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキストテキスト
              </p>
              <span class="font-bold pr-5 hidden">Payment method</span>
              <a-select
                class="pr-5 hidden"
                default-value="Bank"
                style="width: 120px"
                @change="handleChange"
              >
                <a-select-option value="10"> Bank </a-select-option>
                <a-select-option value="20"> Credit card </a-select-option>
              </a-select>
              <button @click="handlePayment()" class="c-btn btn-grey btn-1 w-32 hidden">
                <span class="">Apply</span>
              </button>
            </div>
          </div>
          <!-- <a-divider /> -->
          <div class="mb-16 hidden">
            <SectionContentTitle
              :titleContent="'システムアイ'"
              class="pt-4 text-xl sm:text-sm"
            />
            <div>
              <a-radio-group v-model="siteController" class="sm:flex sm:flex-col">
                <a-radio
                  :value="site.value"
                  v-for="(site, index) in siteControllerList"
                  :key="`site-${index}`"
                >
                  {{ site.label }}
                </a-radio>
              </a-radio-group>
            </div>
          </div>

          <SelectedSubsidyList
            :selectedSubsidyList="selectedSubsidyList"
          />



          <ConfirmPrivacy class="hidden" @change="changeConfirmPrivacy" />
          <!-- <a-divider /> -->
          <div>
                ※個人情報保護法に関する同意文 <br>
                ご記入いただいた個人情報は、弊社サービスの提供のために使用いたします。<br>
                個人情報の取扱につきましては、当社ホームページをご覧ください。
              </div>
          <div class="confirmation">
            <span class="confirmation_title hidden"> 変更・キャンセルについて </span>
            <!-- Buttons -->
            <div class="buttons flex gap-2 justify-center mt-4 mb-4">
              <button @click="handleBack()" class="c-btn btn-white">
                <span class="">戻る</span>
              </button>
              <!-- <button
                @click="handleNext()"
                class="c-btn"
                :class="[isAcceptPrivacy ? 'btn-grey' : 'disabled-btn']"
                :disabled="!isAcceptPrivacy"
              > -->
              <button
                @click="handleNext()"
                class="c-btn btn-grey">
                <span class="">上記の内容で申し込む</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!--    <UseCouponPopup-->
    <!--      :visible="popupUseCoupon"-->
    <!--      @ok="handleEditCoupon"-->
    <!--      @cancel="popupUseCoupon = false"-->
    <!--    />-->
  </div>
</template>

<script>
/* eslint-disable no-unused-vars */
import moment from 'moment'
import _ from 'lodash'
import func_utils from '@/mixins/func_utils'
import plan_utils from '@/mixins/plan_utils'
import { SectionContentTitle, Item, Step } from '@/components/compound'
import CustomerInfo from './components/CustomerInfo'
// import UseCouponPopup from './components/UseCouponPopup'
import { SAVE_ORDER_DETAIL } from '@/store/order/index'
import {
  GET_ITEM_DETAIL,
  SAVE_DATA_BS_APP_02_005,
  GET_TOTAL_POINT,
  GET_PROFILE
} from '@/store/modules/bs_app/actions'
import {
  CREATE_ORDER,
  SAVE_POINT,
  UPDATE_ORDER,
  SAVE_CUSTOMER_PLAN
} from '@/store/modules/plan/actions'
import { GET_MENU_BASIC_INFO } from '@/store/modules/menu/actions'
import { PLAN_BASE_ON_PRICE } from '@/constants/plan'
import ConfirmPrivacy from '@/components/common/ConfirmPrivacy/index.vue'
import SelectedSubsidyList from '../components/SelectedSubsidyList'
import { customPlanToSelectedSubsidyList } from '../utils/dataConverters'
import { COUPON_AGE_TYPE } from '@/constants/coupon'
import { codes as PREFECTURES_CODES } from '@/constants/prefectures'

export default {
  components: {
    Item,
    SectionContentTitle,
    Step,
    CustomerInfo,
    ConfirmPrivacy,
    // UseCouponPopup
    SelectedSubsidyList
  },
  name: 'BS_APP_02_005',
  mixins: [func_utils, plan_utils],
  data() {
    return {
      processing: false,
      customerPlan: null,
      customerInfo: null,
      menuBasicInfo: null,
      dateFormat: 'YYYY-MM-DD',
      infoDetail: {},
      orderInfo: null,
      feePeople: 0,
      numberOfRooms: 1,
      text_note: '',
      checkinTime: '',
      price: {},
      fee4: 0,
      fee5: 20000,
      benepo_point: 0,
      dataPeople: [],
      totalRoomCharge: [],
      roomCharge: 0,
      numberOfMember: [],
      numberOfVisitor: [],
      stayDay: null,
      nightCnt: null,
      stayRoom: null,
      totalAdult: null,
      totalChild: null,
      isUseBenepoint: null,
      textOptionCoupon: '利用しない',
      checkedBenepoint: null,
      valueCheckbox02_001: false,
      representPersonInfo: {},
      questionList: [],
      paymentMethod: '10',
      dataItemOrder: {
        type: 'type-small',
        label: 'アジア・エスニック',
        menu_id: 'メニューNo. 123456',
        menu_content: 'お申し込み種別：お申し込み',
        title1: '相鉄フレッサイン 浜松町大門（施設名',
        title2:
          'スタンダードシンプル＆ベーシック＜素泊まり＞プラン 【禁煙】レディースダブル（プラン名）'
      },
      stay: [
        {
          name: '氏名（漢字・ローマ字）',
          content1: 'BENEFIT',
          content2: 'TARO'
        },
        {
          name: '会員との続柄',
          content1: '本人'
        },
        {
          name: '会員・ビジター',
          content1: '会員'
        },
        {
          name: '性別',
          content1: '男性'
        },
        {
          name: '年齢',
          content1: '56歳'
        }
      ],
      steps: [
        {
          id: 1,
          label: '申請内容を入力'
        },
        {
          id: 2,
          label: '申請者情報を入力'
        },
        {
          id: 3,
          label: '補助金利用申請'
        },
        {
          id: 4,
          label: '申込内容確認'
        },
        {
          id: 5,
          label: '申込完了'
        }
      ],
      siteControllerList: [
        { label: 'TL-リンカーン', value: 'TL-Lincoln' },
        { label: '手間いらず', value: 'Temairazu' },
        { label: 'ねっぱん', value: 'Neppan' },
        { label: 'らく通', value: 'Raku2' },
        { label: 'かんざしクラウド', value: 'Kanxashi' }
      ],
      siteController: 'TL-Lincoln',
      totalAdultPeople: 0,
      totalChildren: 0,
      popupUseCoupon: false,
      orderDetail: null,
      profileInfo: null,
      currentUser: null,
      peopleRoom: null,
      stayParam: null,
      isAcceptPrivacy: false,
      adultPublicSubsidy: 0,
      childPublicSubsidy: 0,
      accommodationAmount: null,
      checkAccommondationWithSubsidy: true,
      arrInputPriceErrorMsg: [],
      selectedRadio: null,
      selectedSubsidyList: [],
      emailTo: null,
    }
  },
  mounted() {
    let orderData = _.get(this.$store.state, 'order.menuBasicInfo.menuNo', null)
    if (orderData === null) {
      this.$router.push("/interrupt")
      return
    }

    this.selectedRadio = _.get(this.$store.getters, 'bs_app.selected_web_radio', null)
    this.dataItemOrder = this.$store.getters['order/get'].dataItemPublicStay
    this.stayDay = _.get(this.publicStayInfo, 'stayDateRoom.date', null)
      ? moment(_.get(this.publicStayInfo, 'stayDateRoom.date', null)).format(
        'YYYY年MM月DD日から'
      )
      : null
    this.adultPublicSubsidy = _.get(this.publicStayInfo, 'adultPublicSubsidy', 0)
    this.childPublicSubsidy = _.get(this.publicStayInfo, 'childPublicSubsidy', 0)
    this.nightCnt = _.get(this.publicStayInfo, 'stayDateRoom.stayNight', null)
    this.stayRoom = _.get(this.publicStayInfo, 'stayDateRoom.stayRoom', null)
    this.getTotalPeople()
    this.peopleRoom = _.get(this.publicStayInfo, 'peopleRoom')
    this.getProfileInfo()
    this.customerPlan = this.getCustomerPlan()
    this.selectedSubsidyList = customPlanToSelectedSubsidyList(this.customerPlan.couponPlanData)
  },
  computed: {
    baseOnPrice() {
      return this.$store.getters.baseOnPrice
    },
    userInfo() {
      return this.$store.getters['auth/get'].user
    },
    publicStayInfo() {
      // return this.$store.getters['order/get'].orderPublicStay
      return _.get(this.$store.getters, 'bs_app.public_stay', null)
    },
    bsAppState() {
      return this.$store.getters.bs_app
    },
    getBsApp02004() {
      return _.get(this.$store.getters, 'bs_app.bs_app_02_004', null)
    },
    getBsApp02008() {
      return _.get(this.$store.getters, 'bs_app.bs_app_02_008', null)
    },
    totalSubsidyDiscount() {
      return _.get(this.customerPlan, 'couponPlanData.totalDiscountAmount', 0)
    },
    totalCost() {
      return this.feePeople -
        (this.fee4 + this.benepo_point + this.totalSubsidyDiscount) >
        0
        ? this.feePeople - (this.fee4 + this.benepo_point + this.totalSubsidyDiscount)
        : 0
    },
    getPlanInfo() {
      return _.cloneDeep(_.get(this.$store.state, 'plan.planDetail', null))
    },
    getInfoDetail() {
      return _.cloneDeep(_.get(this.$store.state, 'bs_app.bs_app.info_detail', null))
    },
    couponOption() {
      return _.get(this.$store.getters.customerPlan, 'couponPlanData.couponOption', null)
    },
    couponLabel() {
      if (this.couponOption === 0) {
        return 'クーポンを最大限利用する'
      } else if (this.couponOption === 1) {
        return '一部のクーポンを利用する'
      }
      return '利用しない'
    },
    benepointLabel() {
      if (this.checkedBenepoint === null || this.checkedBenepoint === 2) {
        return '利用しない'
      } else if (this.checkedBenepoint === 0) {
        return 'すべてのポイントを利用する'
      } else if (this.checkedBenepoint === 1) {
        return '一部のポイントを利用する'
      }
      return '利用しない'
    },
    getOrderInfo() {
      return this.$store.getters.getOrder
    }
  },
  methods: {
    dev(msg){
      // alert(msg)
      // console.log(msg)
    },
    dump(...args){
      // console.log(...args)
    },
    changeConfirmPrivacy(val) {
      this.isAcceptPrivacy = val
    },
    getPlanDetail() {
      return this.$store.getters.planDetail
    },
    getCustomerPlan() {
      return this.$store.getters.customerPlan
    },
    getTotalPeople() {
      const peopleRoom = _.get(this.publicStayInfo, 'peopleRoom', '')
      this.totalAdult = 0
      this.totalChild = 0
      if (peopleRoom) {
        peopleRoom.forEach((element) => {
          this.totalAdult +=
            _.get(element, 'member.man', 0) +
            _.get(element, 'member.woman', 0) +
            _.get(element, 'visitors.man', 0) +
            _.get(element, 'visitors.woman', 0)
          this.totalChild +=
            _.get(element, 'children.childrenMember10', 0) +
            _.get(element, 'children.childrenMember15', 0) +
            _.get(element, 'children.childrenMember20', 0) +
            _.get(element, 'children.childrenMember30', 0) +
            _.get(element, 'children.childrenMember40', 0) +
            _.get(element, 'children.childrenMember50', 0) +
            _.get(element, 'children.childrenVisitor10', 0) +
            _.get(element, 'children.childrenVisitor15', 0) +
            _.get(element, 'children.childrenVisitor20', 0) +
            _.get(element, 'children.childrenVisitor30', 0) +
            _.get(element, 'children.childrenVisitor40', 0) +
            _.get(element, 'children.childrenVisitor50', 0)
        })
      }
    },
    getMemberChild(item) {
      const memberChild =
        _.get(item, 'childrenMember10', 0) +
        _.get(item, 'childrenMember15', 0) +
        _.get(item, 'childrenMember20', 0) +
        _.get(item, 'childrenMember30', 0) +
        _.get(item, 'childrenMember40', 0) +
        _.get(item, 'childrenMember50', 0)
      return memberChild
    },
    getVisitorChild(item) {
      const visitorChild =
        _.get(item, 'childrenVisitor10', 0) +
        _.get(item, 'childrenVisitor15', 0) +
        _.get(item, 'childrenVisitor20', 0) +
        _.get(item, 'childrenVisitor30', 0) +
        _.get(item, 'childrenVisitor40', 0) +
        _.get(item, 'childrenVisitor50', 0)
      return visitorChild
    },
    async getProfileInfo() {
      this.dump('getProfileInfo start')

      const profile = await this.$repositories('user').getUser()
      if (profile?.data) {
        this.dump('getProfileInfo res', profile)
        this.profileInfo = profile 
        this.currentUser = this.$store.getters['auth/get'].user
        this.dump('getProfileInfo currentUser', this.currentUser)
      }
      this.$store.dispatch(GET_PROFILE).then((res) => {
        this.dump('getProfileInfo res', res)
        this.profileInfo = res
        this.currentUser = this.$store.getters['auth/get'].user
        this.dump('getProfileInfo currentUser', this.currentUser)
      })
    },
    caculateAccommodationAmount() {
      let adultMemberChrgP = 0
      let childMemberChrg = 0
      let visitrChrgP = 0
      let visitrChldChrgP = 0

      const peopleRoom = _.get(this.publicStayInfo, 'peopleRoom', '')
      // if (peopleRoom) {
      //   peopleRoom.forEach((el) => {
      //     adultMemberChrgP += _.get(el, 'member.man', 0) * _.get(el, 'member.manPrice', 0)
      //     visitrChrgP += _.get(el, 'visitors.man', 0) * _.get(el, 'visitors.visitorManPrice', 0)
      //     childMemberChrg += _.get(el, 'children.childrenMember10', 0) * _.get(el, 'children.childrenMember10Price', 0)
      //                        + _.get(el, 'children.childrenMember15', 0) * _.get(el, 'children.childrenMember15Price', 0)
      //     visitrChldChrgP += _.get(el, 'children.childrenVisitor10', 0) * _.get(el, 'children.childrenVisitor10Price', 0)
      //   })
      // }
      // this.accommodationAmount = adultMemberChrgP + visitrChrgP + childMemberChrg + visitrChldChrgP
      // this.adultPublicSubsidy = 500
      // this.childPublicSubsidy = 100
      // if((this.accommodationAmount - this.adultPublicSubsidy - this.childPublicSubsidy) < 0) {
      //   this.checkAccommondationWithSubsidy = false
      // }
      if (peopleRoom) {
        peopleRoom.forEach((el, index) => {
          adultMemberChrgP += _.get(el, 'member.man', 0) * _.get(el, 'member.manPrice', 0) - _.get(el, 'member.man', 0) * this.adultPublicSubsidy
          visitrChrgP += _.get(el, 'visitors.man', 0) * _.get(el, 'visitors.visitorManPrice', 0)
          childMemberChrg += _.get(el, 'children.childrenMember10', 0) * _.get(el, 'children.childrenMember10Price', 0)
                             + _.get(el, 'children.childrenMember15', 0) * _.get(el, 'children.childrenMember15Price', 0) - (_.get(el, 'children.childrenMember10', 0) + _.get(el, 'children.childrenMember15', 0)) * this.childPublicSubsidy
          visitrChldChrgP += _.get(el, 'children.childrenVisitor10', 0) * _.get(el, 'children.childrenVisitor10Price', 0)
          if (adultMemberChrgP < 0) {
            this.arrInputPriceErrorMsg.push(
              {
                rooms: index,
                option: '大人'
              }
            )
          }
          if (adultMemberChrgP < 0) {
            this.arrInputPriceErrorMsg.push(
              {
                rooms: index,
                option: '大人'
              }
            )
          }
        
        })
      }
      this.accommodationAmount = adultMemberChrgP + visitrChrgP + childMemberChrg + visitrChldChrgP
      if(this.accommodationAmount < 0) {
        this.checkAccommondationWithSubsidy = false
      }
    },

    /**
     * customerPlanに格納されている、クーポン情報を取得
     * 発注情報構造を形成する
     */
    generateSubsidyReserveData() {
      const stayNightDetails = this.customerPlan?.couponPlanData?.stayNightDetails;
      const sbsidRsvList = []
      stayNightDetails.forEach((night) => {
        const stayDay = night.stayDay
        night.rooms.forEach((room) => {
          room.relationships.forEach((relation) => {
            this.dump("relation",relation)
            relation.appliedCoupons.forEach((coupon) => {
              this.dump("coupon",coupon)
              sbsidRsvList.push({
                subsidyRsvId: coupon.availableData.subsidyId,
                subsidyDetailId: coupon.availableData.subsidyDetailId,
                // customerNo: _.get(this.userInfo, 'contract.customerNo', null),
                customerNo: _.get(this.userInfo, 'ssoCustomerNo', null),
                relationship: _.get(relation, 'relationship.relationshipId', null),
                couponId: _.get(coupon, 'availableData.couponInfo[0].couponId', ''), // 63752 どのcouponIdを指定してもよいため、最初のcouponIdをリクエストボディに含める
                priceId: _.get(coupon, 'applyPrice.subsidyPriceId', null),
                amount: coupon.price,
                familyName: _.get(relation, 'familyName', null),
                firstName: _.get(relation, 'firstName', null),
                aloctRoom: null,
                roomId: null, // 公共の宿に部屋の概念はない
                stayDay: moment(stayDay).format(this.dateFormat),
                // #58333福原さんからの依頼 UI上での大人、もしくは子供のどちらかを優先線して設定
                ageDiv: relation.isChildren ? COUPON_AGE_TYPE.CHILDREN : COUPON_AGE_TYPE.ADULT, // #58333福原さんからの依頼
                groupId: _.get(coupon, 'availableData.groupInfo.groupId', null)
              })
            })
          })
        })
      })
      return sbsidRsvList 
    },
    completeOrderPublicStay() {
      this.dev('completeOrderPublicStay start')
      let adultTotalHeadCntP = 0
      let adultFemaleHeadCntP = 0
      let adultMaleHeadCntP = 0
      let chldHeadCntP = 0
      let chldAHeadCntP = 0
      let chldBHeadCntP = 0
      let chldCHeadCntP = 0
      let chldDHeadCntP = 0
      let chldEHeadCntP = 0
      let chldFHeadCntP = 0
      let vistrAdultFemaleHeadCntP = 0
      let vistrAdultMaleHeadCntP = 0
      let vistrAdultTotalHeadCntP = 0
      let vistrChldAHeadCntP = 0
      let vistrChldBHeadCntP = 0
      let vistrChldCHeadCntP = 0
      let vistrChldDHeadCntP = 0
      let vistrChldEHeadCntP = 0
      let vistrChldFHeadCntP = 0
      let vistrChldHeadCntP = 0
      let childAMemberChrgP = 0
      let childBMemberChrgP = 0
      let adultMemberChrgP = 0
      let visitorChrgP = 0
      let adultBoneSbsidChrgP = 0
      let memberChrgTotalP = 0
      let tieupChrgTotalP = 0
      let boneSbsidChrgTotalP = 0

      const peopleRoom = _.get(this.publicStayInfo, 'peopleRoom', '')
      const stayInfo = _.get(this.publicStayInfo, 'stayDateRoom')
      const stayDay = stayInfo.date
      const stayNights = stayInfo.stayNight
      // const stayRooms = stayInfo.stayRoom
      const dtlChrgHdRoomList = []
      let totalChrg = 0
      let totalTieupChrg = 0

      this.dump('completeOrderPublicStay peopleRoom', peopleRoom)
      if (peopleRoom) {
        peopleRoom.forEach((el, roomIndex) => {
          const roomMemberCnt = _.get(el, 'member.man', 0)
          const roomMemberChrg = _.get(el, 'member.man', 0) * _.get(el, 'member.manPrice', 0)
          const chldAMemberChrg = _.get(el, 'children.childrenMember10', 0) * _.get(el, 'children.childrenMember10Price', 0)
          const chldAMemberPrice  = _.get(el, 'children.childrenMember10Price', 0)
          const chldBMemberChrg = _.get(el, 'children.childrenMember15', 0) * _.get(el, 'children.childrenMember15Price', 0)
          const roomChldMemberCnt = _.get(el, 'children.childrenMember10', 0) +
            _.get(el, 'children.childrenMember15', 0) +
            _.get(el, 'children.childrenMember20', 0) +
            _.get(el, 'children.childrenMember30', 0) +
            _.get(el, 'children.childrenMember40', 0) +
            _.get(el, 'children.childrenMember50', 0)

          const roomVisitorCnt = _.get(el, 'visitors.man', 0)
          const roomVisitorChrg = _.get(el, 'visitors.man', 0) * _.get(el, 'visitors.visitorManPrice', 0)
          const roomChldVisitorCnt = _.get(el, 'children.childrenVisitor10', 0) +
            _.get(el, 'children.childrenVisitor15', 0) +
            _.get(el, 'children.childrenVisitor20', 0) +
            _.get(el, 'children.childrenVisitor30', 0) +
            _.get(el, 'children.childrenVisitor40', 0) +
            _.get(el, 'children.childrenVisitor50', 0)
          const chldAVisitorChrg = _.get(el, 'children.childrenVisitor10', 0) * _.get(el, 'children.childrenVisitor10Price', 0)

          const roomMemberChrgAfterSubsidy = roomMemberChrg - (this.adultPublicSubsidy * roomMemberCnt)
          const chldAMemberChrgAfterSubsidy = chldAMemberChrg - (
            this.childPublicSubsidy * _.get(el, 'children.childrenMember10', 0)
          )
          const chldBMemberChrgAfterSubsidy = chldBMemberChrg
          // const chldBMemberChrgAfterSubsidy = chldBMemberChrg - (
          //   this.childPublicSubsidy * _.get(el, 'children.childrenMember15', 0)
          // )
          memberChrgTotalP += roomMemberChrg + chldAMemberChrg + chldBMemberChrg
          tieupChrgTotalP += roomVisitorChrg + chldAVisitorChrg
          boneSbsidChrgTotalP += this.adultPublicSubsidy * roomMemberCnt + this.childPublicSubsidy * _.get(el, 'children.childrenMember10', 0)

          adultMaleHeadCntP += _.get(el, 'member.man', 0)
          adultFemaleHeadCntP += 0
          adultTotalHeadCntP += roomMemberCnt
          childAMemberChrgP += chldAMemberChrg
          childBMemberChrgP += chldBMemberChrg
          adultMemberChrgP += roomMemberChrg
          visitorChrgP += roomVisitorChrg
          chldAHeadCntP += _.get(el, 'children.childrenMember10', 0)
          chldBHeadCntP += _.get(el, 'children.childrenMember15', 0)
          chldCHeadCntP += _.get(el, 'children.childrenMember20', 0)
          chldDHeadCntP += _.get(el, 'children.childrenMember30', 0)
          chldEHeadCntP += _.get(el, 'children.childrenMember40', 0)
          chldFHeadCntP += _.get(el, 'children.childrenMember50', 0)
          chldHeadCntP += roomChldMemberCnt

          vistrAdultMaleHeadCntP += _.get(el, 'visitors.man', 0)
          vistrAdultFemaleHeadCntP += 0
          vistrAdultTotalHeadCntP += _.get(el, 'visitors.man', 0)
          vistrChldAHeadCntP += _.get(el, 'children.childrenVisitor10', 0)
          vistrChldBHeadCntP += _.get(el, 'children.childrenVisitor15', 0)
          vistrChldCHeadCntP += _.get(el, 'children.childrenVisitor20', 0)
          vistrChldDHeadCntP += _.get(el, 'children.childrenVisitor30', 0)
          vistrChldEHeadCntP += _.get(el, 'children.childrenVisitor40', 0)
          vistrChldFHeadCntP += _.get(el, 'children.childrenVisitor50', 0)
          vistrChldHeadCntP += roomChldVisitorCnt

          if(_.get(el, 'member.man', 0) <  _.get(el, 'visitors.man', 0)) {
            adultBoneSbsidChrgP += visitorChrgP - adultMemberChrgP
          } else if (_.get(el, 'member.man', 0) >  _.get(el, 'visitors.man', 0)) {
            adultBoneSbsidChrgP += visitorChrgP - _.get(el, 'visitors.man', 0) * _.get(el, 'member.manPrice', 0)
          }

          totalChrg += roomMemberChrgAfterSubsidy +
            roomVisitorChrg +
            chldAMemberChrgAfterSubsidy +
            chldBMemberChrgAfterSubsidy +
            chldAVisitorChrg
          // member, visitor
          totalTieupChrg += roomMemberChrg + roomVisitorChrg
          // member, visitor children
          totalTieupChrg += chldAMemberChrg + chldBMemberChrg + chldAVisitorChrg

          for(let i = 0; i < stayNights; i++) {
            const checkDay = moment(stayDay).add(i, 'days')
            dtlChrgHdRoomList.push({
              aloctRoom: `${roomIndex + 1}`,
              stayDay: checkDay.format(this.dateFormat), //
              adultMemberChrg: _.get(el, 'member.manPrice', 0) - this.adultPublicSubsidy,
              childAMemberChrg: chldAMemberPrice ? (chldAMemberPrice - this.childPublicSubsidy) : 0,
              childBMemberChrg: 0,
              childCMemberChrg: +(_.get(el, 'children.childrenMember15Price', 0)),
              childDMemberChrg: 0,
              childEMemberChrg: 0,
              childFMemberChrg: 0,
              adultBoneSbsidChrg: this.adultPublicSubsidy,
              chldABoneSbsidChrg: this.childPublicSubsidy,
              chldBBoneSbsidChrg: 0,
              chldCBoneSbsidChrg: 0,
              chldDBoneSbsidChrg: 0,
              chldEBoneSbsidChrg: 0,
              chldFBoneSbsidChrg: 0,
              adultTotalHeadCnt: roomMemberCnt,
              adultMaleHeadCnt: _.get(el, 'member.man', 0),
              adultFemaleHeadCnt: 0,
              chldHeadCnt: roomChldMemberCnt,
              chldAHeadCnt: _.get(el, 'children.childrenMember10', 0),
              chldBHeadCnt: 0,
              chldCHeadCnt: _.get(el, 'children.childrenMember15', 0),
              chldDHeadCnt: _.get(el, 'children.childrenMember30', 0),
              chldEHeadCnt: _.get(el, 'children.childrenMember40', 0),
              chldFHeadCnt: _.get(el, 'children.childrenMember50', 0),
              vistrAdultTotalHeadCnt: roomVisitorCnt,
              vistrAdultMaleHeadCnt: _.get(el, 'visitors.man', 0),
              vistrAdultFemaleHeadCnt: 0,
              vistrChldHeadCnt: roomChldVisitorCnt,
              vistrChldAHeadCnt: _.get(el, 'children.childrenVisitor10', 0),
              vistrChldBHeadCnt: _.get(el, 'children.childrenVisitor15', 0),
              vistrChldCHeadCnt: _.get(el, 'children.childrenVisitor20', 0),
              vistrChldDHeadCnt: _.get(el, 'children.childrenVisitor30', 0),
              vistrChldEHeadCnt: _.get(el, 'children.childrenVisitor40', 0),
              vistrChldFHeadCnt: _.get(el, 'children.childrenVisitor50', 0)
            })
          }

        })
      }
      const currentUser = this.currentUser
      const profile = this.profileInfo
      const stayParam = _.get(this.publicStayInfo, 'stayParam')
      const stayDayFm = moment(_.get(this.publicStayInfo, 'stayDateRoom.date')).format(
        'YYYY-MM-DD'
      )
      const zipCode1 = _.get(this.getInfoDetail, 'zipCode1', null)
      const zipCode2 = _.get(this.getInfoDetail, 'zipCode2', null)
      const cityAddress = this.getInfoDetail ? _.get(this.getInfoDetail, 'cityAddress', null) : _.get(profile, 'addresses[0].address1', null)
      const apartmentNumber = this.getInfoDetail ? _.get(this.getInfoDetail, 'apartment_number', null) : _.get(profile, 'addresses[0].address2', null)
      const zipCode = this.getInfoDetail ? `${zipCode1 ? zipCode1 : ''}${ zipCode2 ? zipCode2 : ''}` : _.get(profile, 'addresses[0].postalCode', null)
      const prefectureCode = this.getInfoDetail ? _.get(this.getInfoDetail, 'prefectureCode', null) : _.get(profile, 'addresses[0].prefectureCode', null)
      const mobi = this.getInfoDetail ? _.get(this.getInfoDetail, 'tel', null) : _.get(profile, 'tel', null)
      const mail = this.getInfoDetail ? _.get(this.getInfoDetail, 'email', null) : _.get(profile, 'email', null)
      this.emailTo = _.get(this.getInfoDetail, 'email', null)
      const sbsidRsvList = this.generateSubsidyReserveData();
      const sbsidTotal = sbsidRsvList.reduce((sum, current) => sum + current.amount, 0);
      const data = {
        setlSts: '10',
        acptRouteDiv: null,
        applicant: {
          customerNo: _.get(currentUser, 'ssoCustomerNo', null),
          familyNm: _.get(profile, 'familyName', null),
          firstNm: _.get(profile, 'firstName', null),
          resrvFamilyNm: _.get(profile, 'familyNameKana', null),
          resrvFirstNm: _.get(profile, 'firstNameKana', null),
          deliveryAddrFamilyNm: _.get(profile, 'familyName', null),
          deliveryAddrFirstNm: _.get(profile, 'firstName', null),
          deliveryAddrCtgry: '1',
          zipCd: zipCode,
          prefectureCd: prefectureCode,
          addr1: cityAddress,
          addr2: apartmentNumber,
          company: null,
          dept: null,
          email: mail,
          tel1Ctgry: '1',
          tel1: mobi,
          tel2Ctgry: '2',
          tel2: _.get(profile, 'secondTel', null),
          courseId: this.generateNumber(8),
          companyCd: _.get(profile, 'companyCd', null),
          subscriptionId: _.get(currentUser, 'ssoSubscriptionId', null),
          priceDiv: this.CONST_DATA.PRICE_DIV.PRICE_A,
          coverLetterBarcodePrintDiv: null,
        },
        acptDtl: {
          acptDtlNo: null,
          menuNo: _.get(this.dataItemOrder, 'menu_id', ''),
          stayDay: stayDayFm,
          nightCnt: _.get(this.publicStayInfo, 'stayDateRoom.stayNight'),
          roomCnt: _.get(this.publicStayInfo, 'stayDateRoom.stayRoom'),
          receivingMethod: +this.selectedRadio === 1 ? '0' : this.selectedRadio,
          dprtrDate: null,
          fax: null,
          // srvicDiv: _.get(stayParam, 'menuBasicInfo.srvicDiv', null),
          srvicDiv: this.CONST_DATA.SRVIC_DIV.PUBLIC_ACCOMODATION,
          usageDiv: _.get(stayParam, 'usage.usageDiv', null),
          orderPatternDiv: _.get(stayParam, 'applInfo.orderPatternDiv', null),
          catLrgClassNm: _.get(
            stayParam,
            'menuBasicInfo.categoryInfomation.catLrgClassNm',
            null
          ),
          catMidClassNm: _.get(
            stayParam,
            'menuBasicInfo.categoryInfomation.catMidClassNm',
            null
          ),
          catSmlClassNm: _.get(
            stayParam,
            'menuBasicInfo.categoryInfomation.catSmlClassNm',
            null
          ),
          usageLimitId: _.get(stayParam, 'applLimits', null),
          memberChrgTotal: memberChrgTotalP * stayNights,
          boneSbsidChrgTotal: 0,
          tieupChrgTotal: tieupChrgTotalP * stayNights,
          sbsidAplyFlag: sbsidTotal ? '1' : '0',
          sbsidTotal,
        },
        sbsidRsvList,
        dtlChrgHdCntList: dtlChrgHdRoomList,
        stayUsrStrctList: null,
        // [
        //   {
        //     aloctRoom: 1, // 
        //     stayDay: null, // 
        //     adultMemberChrg: adultMemberChrgP,
        //     childAMemberChrg: childAMemberChrgP,
        //     childBMemberChrg: 0,
        //     childCMemberChrg: childCMemberChrgP,
        //     childDMemberChrg: 0,
        //     childEMemberChrg: 0,
        //     childFMemberChrg: 0,
        //     adultBoneSbsidChrg: adultBoneSbsidChrgP,
        //     chldABoneSbsidChrg: 0,
        //     chldBBoneSbsidChrg: 0,
        //     chldCBoneSbsidChrg: 0,
        //     chldDBoneSbsidChrg: 0,
        //     chldEBoneSbsidChrg: 0,
        //     chldFBoneSbsidChrg: 0,
        //     adultTotalHeadCnt: adultTotalHeadCntP,
        //     adultMaleHeadCnt: adultMaleHeadCntP,
        //     adultFemaleHeadCnt: adultFemaleHeadCntP,
        //     chldHeadCnt: chldHeadCntP,
        //     chldAHeadCnt: chldAHeadCntP,
        //     chldBHeadCnt: chldBHeadCntP,
        //     chldCHeadCnt: chldCHeadCntP,
        //     chldDHeadCnt: chldDHeadCntP,
        //     chldEHeadCnt: chldEHeadCntP,
        //     chldFHeadCnt: chldFHeadCntP,
        //     vistrAdultTotalHeadCnt: vistrAdultTotalHeadCntP,
        //     vistrAdultMaleHeadCnt: vistrAdultMaleHeadCntP,
        //     vistrAdultFemaleHeadCnt: vistrAdultFemaleHeadCntP,
        //     vistrChldHeadCnt: vistrChldHeadCntP,
        //     vistrChldAHeadCnt: vistrChldAHeadCntP,
        //     vistrChldBHeadCnt: vistrChldBHeadCntP,
        //     vistrChldCHeadCnt: vistrChldCHeadCntP,
        //     vistrChldDHeadCnt: vistrChldDHeadCntP,
        //     vistrChldEHeadCnt: vistrChldEHeadCntP,
        //     vistrChldFHeadCnt: vistrChldFHeadCntP
        //   }
        // ]
      }
      this.dump("----------------------------------------------------------------")
      this.dump('completeOrderPublicStay createOrderPublicStay request data', data)
      this.dump("----------------------------------------------------------------")

      let errorBool = true
      if (this.processing) {
        return;
      }
      this.processing = true;
      this.$repositories('order')
        .createOrderPulbicStay(data)
        .then(
          (response) => {
            if (response) {
              const query = this.$route.query
              const dataOrder = response
              dataOrder.totalAdult = this.totalAdult
              dataOrder.totalChild = this.totalChild
              const publicStayReqParam = {
                acptNo : dataOrder.acptNo,
                emailTo : this.emailTo
              }
              // API：メール送信
              this.$repositories('order')
              .sendMailToPublicStay(publicStayReqParam)
              .catch((err) => {
                this.processing = false;
                console.error('handleSendPublicStay', err)
              })
              this.$store.commit('order/setCompleteOrderPublicStay', dataOrder)
              this.$router.push({ path: 'register-complete', query })
            }
          },
          (error) => {
            this.processing = false;
            this.$toasted.error(error?.message)
          }
        );
    },
    handleEdit() {
      const query = this.$route.query
      this.$router.push({ path: '/public-stay/menus/register-address', query })
    },
    handleEditUseCoupon() {
      this.popupUseCoupon = true
    },
    handleEditCoupon($event) {
      this.popupUseCoupon = false
      this.customerPlan['couponPlanData'] = $event
      this.$store.dispatch(SAVE_CUSTOMER_PLAN, this.customerPlan)
      // update coupon discount
    },
    handleNext() {
      this.dev("---this.currentUser = this.$store.getters['auth/get'].user---")
      this.dump('handleNext this.currentUser',this.currentUser)
      if (this.currentUser) {
        this.completeOrderPublicStay();
      } else {
        this.dump('handleNext ログイン情報が取得できておらず、受注呼び出し不可')
      }
    },
    handleChange($event) {
      this.paymentMethod = $event
    },
    handleBack() {
      this.$router.go(-1)
    },
    gotoScreen(code) {
      const dataItemOrder = this.$store.getters['order/get'].dataItemPublicStay
      const menuNo = _.get(dataItemOrder, 'menu_id', '')
      switch(code) {
      case 1:
        this.$router.push({ path: '/', query: {} })
        return
      case 2:
        this.$router.push({
          path: `/public-stay/menus/${menuNo}`
        })
        return
      case 3:
        this.$router.push({
          path: '/public-stay/menus/register-rooms'
        })
      }
    },
    getCustomerInfo(el) {
      this.customerInfo = el
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
.modify-button {
  @apply my-6 text-right;
}
.a-select {
  min-width: 100px;
}

::v-deep .ant-collapse-item {
  border: none !important;
  background-color: white !important;
}
</style>
